"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = _interopRequireDefault(require("@amzn/meridian/text"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colorStyles = _interopRequireDefault(require("../enums/colorStyles"));
var _cg = require("react-icons/cg");
/* eslint-disable max-len */

var Question = function Question(_ref) {
  var questionTextFormat = _ref.questionTextFormat,
    question = _ref.question,
    isMandatory = _ref.isMandatory;
  return /*#__PURE__*/_react["default"].createElement(_text["default"], {
    type: questionTextFormat
  }, question, isMandatory && /*#__PURE__*/_react["default"].createElement(_cg.CgAsterisk, {
    "aria-label": "required",
    color: _colorStyles["default"].REQUIRED
  }));
};
Question.propTypes = {
  questionTextFormat: _propTypes["default"].string.isRequired,
  question: _propTypes["default"].string.isRequired,
  isMandatory: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = Question;
//# sourceMappingURL=Question.js.map